export function loadGoogleMaps(apiKey) {
  console.log('Load google maps')
  let script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  document.body.appendChild(script);
}
